import { useEffect, useState } from 'react';

const useDebouncedValue = <T>(value: T, delay = 300) => {
    const [debounced, setDebounced] = useState(value);
    useEffect(() => {
        const id = setTimeout(() => setDebounced(value), delay);
        return () => clearTimeout(id);
    }, [value, delay]);
    return debounced;
};

export default useDebouncedValue;
